import { render, staticRenderFns } from "./CrmAppointmentEvent.vue?vue&type=template&id=0131f904"
import script from "./CrmAppointmentEvent.vue?vue&type=script&lang=ts"
export * from "./CrmAppointmentEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0131f904')) {
      api.createRecord('0131f904', component.options)
    } else {
      api.reload('0131f904', component.options)
    }
    module.hot.accept("./CrmAppointmentEvent.vue?vue&type=template&id=0131f904", function () {
      api.rerender('0131f904', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/events/CrmAppointmentEvent.vue"
export default component.exports